// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___igOtL"};
    if(module.hot) {
      // 1729151133383
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  